module.exports = __webpack_public_path__ + "static/texture-c0ff4f935e2252bdf27cb24cb4861221.png";